<template>
    <v-app id="app">
        <v-app-bar app color="teal ">
            <div class="d-flex align-center">
                <v-img
                    alt="WebGurus"
                    class="shrink mr-2"
                    contain
                    src="https://www.webgurus.biz/wp-content/uploads/2018/03/logo_webgurus@2x.png"
                    transition="scale-transition"
                    width="25"
                    href="https://www.webgurus.biz"
                />
                Webgurus Liquidity Management
            </div>

            <router-link class="routerlink" to="/">
                <v-toolbar-title class="grey--text text--darken-4 nav-header">
                    <a v-offline>{{ !this.$online ? '-offline' : '' }}</a></v-toolbar-title
                >
            </router-link>
            <v-spacer></v-spacer>

            <template v-if="isLogoutShown" id="logout">
                <v-btn icon @click="logOut()">
                    <v-icon>mdi-logout</v-icon>
                </v-btn>
            </template>
        </v-app-bar>

        <v-main>
            <router-view />
            <save-notification v-if="notification" :notification="notification"></save-notification>
            <sync-notification v-if="syncnotification" :notification="notification"></sync-notification>
        </v-main>
    </v-app>
</template>

<script>
    import SaveNotification from '@/components/layouts/SaveNotification.vue';
    import SyncNotification from '@/components/layouts/SyncNotification.vue';
    import { mapGetters } from 'vuex';
    export default {
        name: 'App',
        components: {
            SaveNotification,
            SyncNotification,
        },
        computed: {
            isLogoutShown: {
                get() {
                    return this.$store.getters.getIsLoggedIn;
                },
                set(value) {
                    this.$store.dispatch('setLoggedInState', value);
                },
            },
            notification() {
                return this.$store.getters.getNotification;
            },
            syncnotification() {
                return this.$store.getters.getSyncNotification;
            },
            ...mapGetters({
                isIOSDevice: ['getIsIosDevice'],
            }),
        },
        watch: {
            // isIosDevice() {
            //     return !!navigator.platform && /iPad|iPhone|MacIntel|iPod/.test(navigator.platform) && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            // },
            $online() {
                this.$store.dispatch('showNotification', {
                    message: this.$online ? 'Successfully connected.' : 'No internet connection.',
                    color: this.$online ? 'success' : 'red',
                });
                const channel = new BroadcastChannel('sw-messages');
                channel.addEventListener('message', (event) => {
                    console.log('Received', event.data);
                    this.showSuccessNotification();
                });

                if (this.$online && this.isIOSDevice) {
                    this.$router.go(this.$router.currentRoute);
                    if (window.MessageChannel) {
                        var messageChannel = new MessageChannel();
                        messageChannel.port1.onmessage = (event) => {
                            console.log(event, 'event');
                            this.onMessageSuccess(event);
                        };
                    } else {
                        navigator.serviceWorker.onmessage = (event) => {
                            this.onMessageSuccess(event);
                        };
                    }
                    navigator.serviceWorker.ready.then((reg) => {
                        try {
                            reg.active.postMessage(
                                {
                                    text: 'sync',
                                    port: messageChannel && messageChannel.port2,
                                },
                                [messageChannel && messageChannel.port2]
                            );
                        } catch (e) {
                            //firefox support
                            reg.active.postMessage({
                                text: 'sync',
                            });
                        }
                    });

                    // if (navigator.serviceWorker) {
                    //     navigator.serviceWorker.register('service-worker.js');

                    //     navigator.serviceWorker.addEventListener('message', (event) => {
                    //         // event is a MessageEvent object
                    //         console.log(`The service worker sent me a message: ${event.data}`);
                    //         console.log('event data text', event.data);
                    //         if (event.data == 'doNotification') {
                    //             console.log('doiosnotification');
                    //             this.showSuccessNotification();
                    //         }
                    //     });

                    //     navigator.serviceWorker.ready.then((registration) => {
                    //         registration.active.postMessage('iamios');
                    //     });
                    // }
                    // const channel1 = new BroadcastChannel('ios-messages');
                    // channel1.addEventListener('message', (event) => {
                    //     console.log('IOS-MESSAGE', event.data);
                    //     console.log(event.data.title);

                    //     this.showSuccessNotification();
                    //     console.log('notification kene');
                    // });
                }
            },
        },

        methods: {
            logOut() {
                this.$router.go({ path: '/' });
                this.isLogoutShown = false;
                sessionStorage.removeItem('isLoggedIn');
            },
            showSuccessNotification() {
                this.$store.dispatch('showNotification', {
                    message: 'Syncronized',
                    color: 'cyan',
                    position: 'top',
                });
            },
            onMessageSuccess(event) {
                if (event.data == 'doNotification') {
                    console.log('donotification app vue');
                    this.$nextTick(() => {
                        this.showSuccessNotification();
                    });
                }
            },
            iosNotification() {
                this.$store.dispatch('showNotification', {
                    message: 'iooooos',
                    color: 'cyan',
                    position: 'bottom',
                });
            },
        },
        created() {
            if (!this.isIOSDevice) Notification.requestPermission();
        },
        mounted() {
            console.log('ios vagy sem', this.isIOSDevice);

            // if (this.isIOSDevice) {
            //     console.log('ez egy ios');
            //     this.$store.dispatch('showNotification', {
            //         message: 'i am iooooos.',
            //         color: 'red',
            //         position: 'top',
            //     });
            // }
        },
    };
</script>

<style lang="scss">
    .nav-header {
        font-family: Bariol;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        letter-spacing: 0.5px !important;
    }

    .routerlink {
        text-decoration: none;
    }

    @font-face {
        font-family: 'Bariol';
        src: url('./assets/Bariol/Bariol_Regular.otf'), url('./assets/Bariol/Bariol_Bold.otf'), url('./assets/Bariol/Bariol_Light.otf');
    }

    $body-font-family: 'Bariol', 'Roboto', sans-serif !important;

    .font-bariol {
        font-family: $body-font-family;
    }

    #inspire {
        background-color: #f6f6f6;
    }
    #notification {
        //position: absolute;
        width: 319px;
        height: 67px;

        /* Yellow */
        background: #f2c94c;
        border-radius: 15px;
        margin-top: 580px;
        margin-left: 5%;
    }
    #isOffline {
        color: #f6f6f6;
    }
    // #app {
    //     background-color: teal;
    // }
</style>
